<template>
  <div></div>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useEntranceGuidRedirectPageQuery } from './EntranceGUIDRedirectPage.generated'

const router = useRouter()
const route = useRoute()
const { result } = useEntranceGuidRedirectPageQuery()

watch(
  result,
  result => {
    if (result && result.entrances) {
      const path = route.path === '/' ? '/dashboard' : route.path
      router.replace({
        ...route,
        path: `/e/${result.entrances[0].guid}${path}`,
      })
    }
  },
  { immediate: true }
)
</script>
